import { UpdateShopStatusService } from "../Infrastructure/Business.service";

export default function UpdateShopStatusLogic(data){
  return UpdateShopStatusService(data);
}